// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"ade2f76f","650":"8b4283ce"}[chunkId] + ".chunk.css";
};